<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';
	import {
		getStepErrors,
		getStepper,
		getStepStore,
		type StepDisplayer,
		type StepValidator
	} from './stepper';
	import { fly } from 'svelte/transition';
	import Cta from '$lib/components/Global/Cta.svelte';
	import __ from '$lib/stores/TranslationStore';
	import StepDataWrapper from './StepDataWrapper.svelte';

	export let title: string;
	export let actionButton: boolean = true;
	export let validate: StepValidator = {};
	export let displayCaption: StepDisplayer | null = null;
	export let required: string[] = [];
	const stepper = getStepper();
	let hash: symbol = stepper.createStep(title, validate, required, displayCaption);

	const errors = getStepErrors(hash);

	onMount(() => {
		return () => {
			stepper.deleteStep(hash as symbol);
		};
	});

	// const errors =
	const step = getStepStore(hash);
	$: stepNumber = $stepper.getStepNumber(hash);

	$: isCurrentStep = hash === $stepper.getCurrentStep()?.hash;
	$: canGoNext =
		$step?.data._alreadyChanged &&
		Object.keys($errors).length === 0 &&
		!$step.requiredFields.some((field) => {
			const fieldData = $step.data[field];
			if (Array.isArray(fieldData)) {
				return fieldData.length === 0;
			}

			return [null, undefined, ''].includes(fieldData as any);
		});
	$: isLastStep = $stepper.isLastStep(hash);

	const dispatch = createEventDispatcher();
</script>

{#if !$stepper.showResult && isCurrentStep}
	<form class="col-[1/2] row-[1/2]" on:submit|preventDefault>
		<div
			class="flex flex-col justify-between gap-5 lg:gap-12"
			in:fly={{ y: 100, duration: 500 }}
			out:fly={{ y: -100, duration: 0 }}
		>
			<div class="flex flex-col">
				<div class="flex flex-col gap-8 overflow-hidden">
					<div class="flex flex-col gap-2">
						<div class="flex items-start gap-3 text-xl/6 lg:text-[32px]/[40px]">
							<slot {stepNumber} {title} name="header">
								<span>{stepNumber}.</span>
								<h2>{@html title}</h2>
							</slot>
						</div>
						<slot name="caption" />
					</div>
					<StepDataWrapper {hash}>
						<slot />
					</StepDataWrapper>
				</div>
			</div>
			{#if actionButton}
				<div class="flex">
					<Cta
						class="h-[60px] flex-1 transition-colors duration-150 lg:min-w-[290px] lg:grow-0 {canGoNext
							? ''
							: 'bg-inactive text-slate-inactive'}"
						type="button"
						props={{
							disabled: !canGoNext,
							type: 'submit'
						}}
						on:click={() => {
							if (canGoNext) {
								if (isLastStep) {
									dispatch('complete');
									return;
								}
								stepper.goNextStep();
							}
						}}
					>
						{!isLastStep ? $__('Continuar') : $__('Ver resultado')}
					</Cta>
				</div>
			{/if}
		</div>
	</form>
{/if}
